import { Map as ImmutableMap, fromJS } from 'immutable';

// TODO #2480: Understand arrayToMap usage and write tests if necessary
export const arrayToMap = (array, key) => {
  return array.reduce((map, element) => {
    return map.set(isNaN(+element[key]) ? element[key] : +element[key], fromJS(element));
  }, ImmutableMap());
};